import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { createGaActionCreator } from '../../utils';
import {
    APPOINTMENT_INFO_GA_CATEGORY,
    REVIEW_GA_CATEGORY,
    GaActionText,
} from './constants';

const CLEAR_TIMESLOT_CONSTRAINT = 'ai/CLEAR_TIMESLOT_CONSTRAINT';
const SET_TIMESLOT_CONSTRAINT = 'ai/SET_TIMESLOT_CONSTRAINT';
const SHOW_INSURANCE_ERROR = 'ai/SHOW_INSURANCE_ERROR';
const SHOW_PAY_FOR_SELF_ERROR = 'ai/SHOW_PAY_FOR_SELF_ERROR';
const TRACK_MADE_IT_TO_BOOKING_FLOW =
    '@@apointmentinfo/TRACK_MADE_IT_TO_BOOKING_FLOW';
const TRACK_CHANGE_TO_EXISTING_PATIENT = 'ai/TRACK_CHANGE_TO_EXISTING_PATIENT';
const TRACK_CHANGE_TO_NEW_PATIENT = 'ai/TRACK_CHANGE_TO_NEW_PATIENT';
const TRACK_IS_NEW_PATIENT = 'ai/TRACK_IS_NEW_PATIENT';
const TRACK_HAS_SEEN_THIS_DOCTOR_BEFORE =
    'ai/TRACK_HAS_SEEN_THIS_DOCTOR_BEFORE';
const TRACK_DISPLAY_SELECT_NEW_TIME_POINTER =
    'ai/TRACK_DISPLAY_SELECT_NEW_TIME_POINTER';
const TRACK_SELECT_APPOINTMENT_TIME = 'ai/TRACK_SELECT_APPOINTMENT_TIME';
const TRACK_CHANGE_APPOINTMENT_TIME_CLICK =
    'ai/TRACK_CHANGE_APPOINTMENT_TIME_CLICK';
const TRACK_CLICK_CONTINUE = 'ai/TRACK_CLICK_CONTINUE';
const TRACK_PROCEDURE_MAY_NOT_BE_COVERED_TOOLTIP_DISPLAYED =
    'ai/TRACK_PROCEDURE_MAY_NOT_BE_COVERED_TOOLTIP_DISPLAYED';

const TRACK_CARD_CAPTURE_ELIGIBLE_AT_BOOKING =
    'ai/TRACK_CARD_CAPTURE_ELIGIBLE_AT_BOOKING';
const TRACK_PLAN_DETAILS_SHOWN = 'ai/TRACK_PLAN_DETAILS_SHOWN';
const TRACK_ELIGIBLE_COVERAGE_PRECHECK_STATUS =
    'ai/TRACK_ELIGIBLE_COVERAGE_PRECHECK_STATUS';
const TRACK_INSURANCE_CARD_ATTACHED_WITH_BOOKING =
    'ai/TRACK_INSURANCE_CARD_ATTACHED_WITH_BOOKING';
const TRACK_VIEW_PAY_FOR_SELF_ERROR = 'ai/TRACK_VIEW_PAY_FOR_SELF_ERROR';

export const AppointmentInfoPageActions = {
    CLEAR_TIMESLOT_CONSTRAINT,
    SET_TIMESLOT_CONSTRAINT,
    TRACK_PLAN_DETAILS_SHOWN,
    TRACK_ELIGIBLE_COVERAGE_PRECHECK_STATUS,
    SHOW_INSURANCE_ERROR,
    SHOW_PAY_FOR_SELF_ERROR,
    TRACK_MADE_IT_TO_BOOKING_FLOW,
    TRACK_CHANGE_TO_EXISTING_PATIENT,
    TRACK_CHANGE_TO_NEW_PATIENT,
    TRACK_IS_NEW_PATIENT,
    TRACK_HAS_SEEN_THIS_DOCTOR_BEFORE,
    TRACK_DISPLAY_SELECT_NEW_TIME_POINTER,
    TRACK_SELECT_APPOINTMENT_TIME,
    TRACK_CHANGE_APPOINTMENT_TIME_CLICK,
    TRACK_CLICK_CONTINUE,
    TRACK_PROCEDURE_MAY_NOT_BE_COVERED_TOOLTIP_DISPLAYED,
    TRACK_VIEW_PAY_FOR_SELF_ERROR,
};

export const clearTimeslotConstraint = () => ({
    type: CLEAR_TIMESLOT_CONSTRAINT,
});

export const setTimeslotConstraint = () => ({
    type: SET_TIMESLOT_CONSTRAINT,
});

export const showInsurancePickerError = () => ({
    type: SHOW_INSURANCE_ERROR,
});

export const showPayForSelfError = () => ({
    type: SHOW_PAY_FOR_SELF_ERROR,
});

/* region Tracking Actions */

export const trackMadeItToBookingFlow = () => {
    const baseAction = createGaActionCreator(
        TRACK_MADE_IT_TO_BOOKING_FLOW,
        REVIEW_GA_CATEGORY,
        GaActionText.trackMadeItToBookingFlow
    );

    if (window.dataLayer) {
        window.dataLayer.push({
            // eslint-disable-next-line
            event: `[${REVIEW_GA_CATEGORY}] ${GaActionText.trackMadeItToBookingFlow}`,
        });
    }

    return baseAction;
};

export const trackChangeToExistingPatient = () => ({
    type: TRACK_CHANGE_TO_EXISTING_PATIENT,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackChangeToExistingPatient,
        },
    },
});

export const trackChangeToNewPatient = () => ({
    type: TRACK_CHANGE_TO_NEW_PATIENT,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackChangeToNewPatient,
        },
    },
});

export const trackIsNewPatient = () => ({
    type: TRACK_IS_NEW_PATIENT,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackIsNewPatient,
        },
    },
});

export const trackHasSeenThisDoctorBefore = () => ({
    type: TRACK_HAS_SEEN_THIS_DOCTOR_BEFORE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackHasSeenThisDoctorBefore,
        },
    },
});

export const trackDisplaySelectNewTimePointer = () => ({
    type: TRACK_DISPLAY_SELECT_NEW_TIME_POINTER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackDisplaySelectNewTimePointer,
        },
    },
});

export const trackSelectAppointmentTime = () => ({
    type: TRACK_SELECT_APPOINTMENT_TIME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackSelectAppointmentTime,
        },
    },
});

export const trackChangeAppointmentTimeClick = () => ({
    type: TRACK_CHANGE_APPOINTMENT_TIME_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackChangeAppointmentTimeClick,
        },
    },
});

export const trackProcedureMayNotBeCoveredTooltipDisplayed = () => ({
    type: TRACK_PROCEDURE_MAY_NOT_BE_COVERED_TOOLTIP_DISPLAYED,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackProcedureMayNotBeCoveredTooltipDisplayed,
        },
    },
});

export const trackClickContinue = () => ({
    type: TRACK_CLICK_CONTINUE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackClickContinue,
        },
    },
});

export const trackCardCaptureEligibleAtBooking = () => ({
    type: TRACK_CARD_CAPTURE_ELIGIBLE_AT_BOOKING,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackCardCaptureEligibleAtBooking,
        },
    },
});

export const trackInsuranceCardAttachedWithBooking = () => ({
    type: TRACK_INSURANCE_CARD_ATTACHED_WITH_BOOKING,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackInsuranceCardAttachedWithBooking,
        },
    },
});

export const trackViewedPayForSelfError = () => ({
    type: TRACK_VIEW_PAY_FOR_SELF_ERROR,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_INFO_GA_CATEGORY,
            action: GaActionText.trackPayForSelfError,
        },
    },
});

/* endregion Tracking Actions */

export const AppointmentInfoPageActionCreators = {
    trackMadeItToBookingFlow,
    trackChangeToExistingPatient,
    trackChangeToNewPatient,
    trackIsNewPatient,
    trackHasSeenThisDoctorBefore,
    trackDisplaySelectNewTimePointer,
    trackSelectAppointmentTime,
    trackChangeAppointmentTimeClick,
    trackProcedureMayNotBeCoveredTooltipDisplayed,
    trackClickContinue,
    trackCardCaptureEligibleAtBooking,
    trackInsuranceCardAttachedWithBooking,
    trackViewedPayForSelfError,
};
